import { Image } from '@tiptap/extension-image';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { ImageNodeWrapper } from './ImageNodeWrapper';

export const ImageExtension = Image.extend({
  addNodeView() {
    return ReactNodeViewRenderer(ImageNodeWrapper);
  },
});
